import * as React from "react";
const SvgEthereum = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 33, height: 32, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#6FCB94", d: "M16.5 4 9.13 16.22l7.37 4.35 7.37-4.35zm0 24L9.13 17.62 16.5 22l7.37-4.38z" }));
export default SvgEthereum;
